<template>
  <div class="modal fixed top-0 left-0 h-full w-full px-4" style="background-color: rgba(0,0,0,.5);">
    <div class="modal-wrapper md:w-2/3 flex flex-col shadow-xl mx-auto rounded overflow-hidden md:max-w-xl h-full">
      <div class="bg-white p-4 border-b-2 border-gray-300 flex items-center justify-between">
        <h1 class="text-red-500 text-2xl">{{ header}}</h1>
        <a href="#" class="block py-1 px-2 outline-none border-2 border-transparent active:border-red-500 hover:text-red-500" @click.prevent="close">
          <font-awesome-icon :icon="['far', 'times']" size="lg" />
        </a>
      </div>
      <div class="modal-body bg-white p-4 h-full overflow-y-scroll shadow-inner">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['header'],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .modal {
    padding-top: 100px;
    z-index: 1000;
  }
  .modal-wrapper {
    max-height: calc(100vh - 200px);
  }
  .modal-body p {
    margin-bottom: 1.5em;
  }
</style>